import request from '@/utils/request_cn';

/**** 招商活动标签接口 begin ****/

export async function getTagList(params) {
  return (await request({
    url: `/basic-backend/promotion/tag/list`,
    method: "get",
    params,
  })).data;
}
export async function getTagListTotal(params) {
  return (await request({
    url: `/basic-backend/promotion/tag/total`,
    method: "get",
    params,
  })).data;
}
export async function validateName(params) {
  return (await request({
    url: `/basic-backend/promotion/tag/checkName`,
    method: "get",
    params,
  })).data;
}
export async function updateTag(data) {
  return (await request({
    url: `/basic-backend/promotion/tag/update`,
    method: "post",
    data,
  })).data;
}
export async function createTag(data) {
  return (await request({
    url: `/basic-backend/promotion/tag/create`,
    method: "post",
    data,
  })).data;
}
export async function validateIsUse(id) { //校验标签是否有活动在使用接口
  return (await request({
    url: `/basic-backend/promotion/tag/enable?promotionTagId=${id}`,
    method: "get",
  })).data;
}
export async function delTag(id) {
  return (await request({
    url: `/basic-backend/promotion/tag/${id}`,
    method: "delete",
  })).data;
}

/**** 招商活动列表接口 begin ****/

export async function getInvestmentList(params) {
  return (await request({
    url: `/basic-backend/promotion/investment/list`,
    method: "get",
    params,
  })).data;
}
export async function getInvestmentListTotal(params) {
  return (await request({
    url: `/basic-backend/promotion/investment/total`,
    method: "get",
    params,
  })).data;
}
export async function getInvestmentDetail(salesPromotionId) {
  return (await request({
    url: `/basic-backend/promotion/investment/detail/${salesPromotionId}`,
    method: "get",
  })).data;
}

export async function getInvestmentResources() { //获取活动资源列表
  return (await request({
    url: `/basic-backend/promotion/investment/resources`,
    method: "get",
  })).data;
}

export async function getInvestmentTags() { //获取活动标签列表
  return (await request({
    url: `/basic-backend/promotion/investment/tags`,
    method: "get",
  })).data;
}

export async function validateEnName(params) { //校验英文活动名称
  return (await request({
    url: `/basic-backend/promotion/investment/checkEnName`,
    method: "get",
    params,
  })).data;
}
export async function validateCnName(params) { //校验中文活动名称
  return (await request({
    url: `/basic-backend/promotion/investment/checkName`,
    method: "get",
    params,
  })).data;
}

export async function getCountries(params) { //获取国家list
  return (await request({
    url: `/basic-backend/promotion/investment/countries`,
    method: "get",
    params,
  })).data;
}

export async function getVendors(params) { //获取店铺list
  return (await request({
    url: `/basic-backend/promotion/investment/vendors`,
    method: "get",
    params,
  })).data;
}






export async function commit(data) {
  return (await request({
    url: `/basic-backend/promotion/investment/commit`,
    method: "post",
    data,
  })).data;
}





export async function getVendorList(params) { //活动商品管理买手店
  return (await request({
    url: `/basic-backend/promotion/product/vendor/list`,
    method: "get",
    params,
  })).data;
}
export async function getVendorProductList(data) { //活动商品管理买手店 进入买手店 商品list
  return (await request({
    url: `/basic-backend/promotion/product/vendor/product/list`,
    method: "post",
    data,
  })).data;
}
export async function statusChange(data) { //活动商品管理买手店 进入买手店 商品状态更新
  return (await request({
    url: `/basic-backend/promotion/product/product/status/change`,
    method: "post",
    data,
  })).data;
}
/**** 通用接口 begin ****/
export async function getVendorsByVendorName() { // 买手店
  return (await request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller/regionFilter`,
    method: 'post',
    data: {
      needChildVendorFlag: false,
    },
  })).data;
}
export async function getBrandList() { //品牌
  return (await request({
    url: `/product-service/brand/list`,
    method: 'get',
  })).data;
}
export async function category() { //分类
  return (await request({
    url: `/basic-backend/category/tree`,
    method: 'get',
  })).data;
}
export async function seasonList() { //季节
  return (await request({
    url: `/product-service/season/activeList`,
    method: 'get',
  })).data;
}


///getVendorSupplyPriceMethod查询该店铺的接入价格方式
export async function getVendorSupplyPriceMethod(params) {
  return (await request({
    url: `/basic-backend/vendor/discount/type`,
    method: 'GET',
    params,
  })).data;
}

export function getDiscountByCacheKey(params) {
  return request({
    url: `/basic-backend/promotion/investment/cache`,
    method: 'GET',
    params,
  });
}

export function cleanDiscountCache(keys) {
  return request({
    url: `/basic-backend/promotion/investment/clean/cache`,
    method: 'GET',
    params: {
      keys,
    },
  })
}

export async function getDiscountTemplateUrl(type) {
  return (await request({
    url: `/basic-backend/promotion/investment/download`,
    method: 'GET',
    params: {
      type,
    },
  })).data;
}
export async function usedListUsingGET(id) {
  return (await request({
    url: `/basic-backend/promotion/tag/used/list?salesPromotionId=${id}`,
    method: 'GET',
  })).data;
}
export const uploadDiscountExcel = `${process.env.BASE_URL}basic-backend/promotion/investment/upload`;


export function getMerchantAccountList(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/list',
    method: 'post',
    data
  })
}

export function getMerchantStockLocationList(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/stockLocation/list',
    params
  })
}

export function getMerchantVendorList(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/findVendorInfo',
    params
  })
}

export function getVendorData(params) {
  return request({
    url: '/sc-basic-backend/vendor/list',
    params
  })
}

export function getMerchantTaxRefundCompanyList() {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/taxRefundCompany/list',
  })
}

export function merchantAccountRecharge(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/recharge/amount',
    method: 'post',
    data
  })
}

export function getMerchantBrandList() {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/brand/list',
  })
}

export function createOrUpdateAccount(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/createOrUpdateAccount',
    method: 'post',
    data
  })
}

export function findAccountInfoById(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/findAccountInfoById',
    params
  })
}

export function checkAccountStockLocationRefer(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/checkAccountStockLocationRefer',
    method: 'post',
    data
  })
}

export async function fileUpload() {
  return request({
    url: `/oss/file-upload-auth-sts`,
    method: 'GET'
  });
}

export function getPaymentApproveList(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/list',
    method: 'post',
    data
  })
}

export function downloadPaymentApply(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/download/apply',
    method: 'post',
    data
  })
}

export function payBank(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/bank/pay',
    method: 'post',
    data
  })
}

export function payBalance(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/balance/pay',
    method: 'post',
    data
  })
}

export function findAccountBalanceById(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/account/manage/findAccountBalanceById',
    params
  })
}

export function rejectPayment(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/reject',
    params
  })
}

export function paymentDetail(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/apply/detail',
    params
  })
}

export function findPaymentRecord(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/findPaymentRecord',
    params
  })
}

export function getTaxRefundCompanyList(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/taxRefundCompany/manage/list',
    method: 'post',
    data
  })
}

export function createOrUpdateTaxRefundCompany(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/taxRefundCompany/manage/createOrUpdateTaxRefundCompany',
    method: 'post',
    data
  })
}

export function addPayCertificate(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/payCertificate/add',
    method: 'post',
    data
  })
}

export function getPayInfo(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/pay/info',
    params
  })
}

export function payPayment(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/payment/manage/pay',
    method: 'post',
    data
  })
}

export function getRefundList(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/refund/manage/list',
    method: 'post',
    data
  })
}

export function downloadRefundApply(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/refund/manage/download/apply',
    method: 'post',
    data
  })
}

export function submitRefundApply(data) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/refund/manage/refund',
    method: 'post',
    data
  })
}

export function rejectRefund(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/refund/manage/reject',
    params
  })
}

export function getRefundChannelList(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/refund/manage/channel/list',
    params
  })
}

export function findRefundRecord(params) {
  return request({
    url: '/sc-basic-merchant-backend/merchant/refund/manage/findRefundRecord',
    params
  })
}

// setPrice POST /promotion/investment/update/sale/price/type

export async function setPrice(id, type) {
  return (await request({
    url: `/basic-backend/promotion/investment/update/sale/price/type?salesPromotionId=${id}&salePriceType=${type}`,
    method: 'post',
  })).data;
}

//POST /promotion/product/price/cut/{promotionId}/change/sale/price/type
//修改专题状态1：全部降价 2： 全部不降价 3：指定不降价
export async function changeSalePriceType(promotionId,type) {
  return (await request({
    url: `/basic-backend/promotion/product/price/cut/${promotionId}/change/sale/price/type?salePriceType=${type}`,
    method: 'post',
  })).data;
}


export function getVendorWithBrandList(data) {
  return request({
    url: '/sc-basic-merchant-backend/vendor/counter/brand/list',
    method: 'post',
    data,
  })
}

export function batchAddOrUpdateVendorCounter(data) {
  return request({
    url: '/sc-basic-merchant-backend/vendor/counter/brand/batchAddOrUpdate',
    method: 'post',
    data,
  })
}

export function updateVendorCounter(data) {
  return request({
    url: '/sc-basic-merchant-backend/vendor/counter/brand/edit',
    method: 'post',
    data,
  })
}

export function delVendorCounterByIds(params) {
  return request({
    url: '/sc-basic-merchant-backend/vendor/counter/brand/delByIds',
    params,
  })
}

export function getCounterSpuList(data) {
  return request({
    url: '/sc-basic-merchant-backend/counter/spu/manager/list',
    method: 'post',
    data,
  })
}

export function delCounterSpuByIds(params) {
  return request({
    url: '/sc-basic-merchant-backend/counter/spu/manager/delBySpuIds',
    params,
  })
}

export function delCounterSpuByParam(data) {
  return request({
    url: '/sc-basic-merchant-backend/counter/spu/manager/delByParam',
    method: 'post',
    data,
  })
}

export function addCounterSpuBySpuIds(data) {
  return request({
    url: '/sc-basic-merchant-backend/counter/spu/manager/addBySpuIds',
    method: 'post',
    data,
  })
}

export function confirmAddCounterSpuBySpuIds(data) {
  return request({
    url: '/sc-basic-merchant-backend/counter/spu/manager/confirmAddBySpuIds',
    method: 'post',
    data,
  })
}

export function addCounterSpuByParam(data) {
  return request({
    url: '/sc-basic-merchant-backend/counter/spu/manager/addByParam',
    method: 'post',
    data,
  })
}

export function confirmAddCounterSpuByParam(data) {
  return request({
    url: '/sc-basic-merchant-backend/counter/spu/manager/confirmAddByParam',
    method: 'post',
    data,
  })
}

export function getVendorListByBrandId(params) {
  return request({
    url: '/sc-basic-merchant-backend/vendor/counter/brand/getListByBrandId',
    params,
  })
}

export function checkBrand(data) {
  return request({
    url: '/sc-basic-merchant-backend/counter/spu/manager/checkBrand',
    method: 'post',
    data,
  })
}

export function getTaxRefundsCommissionList(data) {
  return request({
    url: '/sc-basic-merchant-backend/taxRefunds/commission/ratio/page/list',
    method: 'post',
    data,
  })
}

export function saveTaxRefundsCommissionRatio(data) {
  return request({
    url: '/sc-basic-merchant-backend/taxRefunds/commission/ratio',
    method: 'post',
    data,
  })
}

export function getTaxRefundsCommissionVendorList(params) {
  return request({
    url: '/sc-basic-merchant-backend/taxRefunds/commission/ratio/list',
    params,
  })
}

export function getCounterVendorList(data) {
  return request({
    url: '/sc-merchant-common/v2/vendors/param',
    method: 'post',
    data,
  })
}

export async function getReptileVendorList() {
  return (await request({
    url: '/sc-merchant-common/v2/vendors/reptileVendorList',
    method: 'post',
  })).data;
}

